import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import BackLink from '../components/BackLink'
import Layout from '../components/Layout'
import ProfileBody from '../components/ProfileBody'
import { useUser } from '../contexts/UserContext'

export default function Profile() {
  const navigate = useNavigate()
  const { userId } = useParams()
  const { user: currentUser } = useUser()

  const isOwnProfile = !userId || userId === currentUser?.id
  const targetUserId = userId || currentUser?.id

  // Redirect /profile to /profile/:userId for shareability
  useEffect(() => {
    if (!userId && currentUser?.id) {
      navigate(`/profile/${currentUser.id}${window.location.search}`, { replace: true })
    }
  }, [userId, currentUser?.id, navigate])

  // Show loading while waiting for redirect
  if (!userId && !currentUser) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-96">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
            <p className="mt-4 text-muted-foreground">Loading profile...</p>
          </div>
        </div>
      </Layout>
    )
  }

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 overflow-x-hidden">
        {/* Back button when viewing someone else's profile */}
        {!isOwnProfile && (
          <BackLink label="Back" className="mb-4" />
        )}

        <ProfileBody userId={targetUserId} isOwnProfile={isOwnProfile} />
      </div>
    </Layout>
  )
}
